import * as React from "react"
import { Dialog as MuiDialog, DialogTitle, DialogContent, Button, DialogContentText } from '@mui/material';

import { useLocation } from "@reach/router"

import { ReactComponent as Close } from 'images/icons/close.svg';

const Prompt = React.forwardRef((props, ref) => {
	const [internalIsOpen, setInternalIsOpen] = React.useState(props.defaultIsOpen || false);
	const dialogProps = {
		...props,
		variant: 'dialog'
	};
	const onClose = props.onClose;
	const isControlled = props.isOpen !== undefined;
	const isOpen = (isControlled ? props.isOpen : internalIsOpen);
	const clean = ['children', 'title', 'titleButtons', 'onClose', 'actions', 'defaultIsOpen', 'isOpen'];
	clean.forEach(prop => delete dialogProps[prop]);

	const location = useLocation();
	const initialPathRef = React.useRef(location.pathname);
	const onCloseRef = React.useRef(onClose);
	onCloseRef.current = onClose;

	React.useEffect(() => {
		if (location.pathname === initialPathRef.current) return;
		initialPathRef.current = location.pathname;
		if (onCloseRef.current) onCloseRef.current({}, "routeChange");
		if (!isControlled) setInternalIsOpen(false);
	}, [location.pathname, isControlled]);

	const handleClose = (evt) => {
		if (onClose)onClose(evt, "closeButtonClick");
		if (!isControlled)setInternalIsOpen(false);
	}

	const handleOnClose = (evt, reason) => {
		if (onClose)onClose(evt, reason);
		if (!isControlled)setInternalIsOpen(false);
	}

	React.useImperativeHandle(ref, () => {
		return {
			close: () => {
				setInternalIsOpen(false);
			},
			open: () => {
				setInternalIsOpen(true);
			},
		}
	}, []);

	return (
		<>
			<MuiDialog {...dialogProps} variant="prompt" open={isOpen} onClose={handleOnClose}>
				<div className="Prompt-titleBar">
					<Button onClick={handleClose} className="Prompt-closeButton" disableRipple variant="icon" aria-label="Close"><Close /></Button>
					{ props.title && <DialogTitle>{props.title}</DialogTitle> }
				</div>
				<DialogContent>
					<DialogContentText>
						{props.children}
					</DialogContentText>
				</DialogContent>
			</MuiDialog>
		</>
	)
});

export default Prompt;